module.exports = __webpack_public_path__ + "static/faq-44faa6db9b0dcc65bbe9074723b4aa7a.png";